import { FW } from './../framework/Framework';
export class SoundManager {

    private soundVolume: { [key: string]: number } = {};

    importSoundXML(xml: XMLDocument): void {
        let xmls = xml.getElementsByTagName('sound');
        for (let i = 0; i < xmls.length; ++i) {
            let soundxml = xmls[i];
            let alias: string = soundxml.getAttribute('id');
            console.log('load sound: ' + soundxml.getAttribute('id') + ' => ' + soundxml.getAttribute('url'));
            FW.addPreloadResource(alias, soundxml.getAttribute('url'));
            if (soundxml.hasAttribute('vol')) {
                this.soundVolume[alias] = parseFloat(soundxml.getAttribute('vol'));
            }
        }
    }

    public play(alias: string, loop: boolean = false): PIXI.sound.IMediaInstance {
        return FW.playSound(alias, {
            loop: loop,
            volume: this.soundVolume[alias] || 1
        })
    }

}

export const soundManager: SoundManager = new SoundManager();


// WEBPACK FOOTER //
// ./src/worlds/SoundManager.ts